import { render, staticRenderFns } from "./LibraryBookTemplate.vue?vue&type=template&id=fb9693d6&scoped=true&"
import script from "./LibraryBookTemplate.vue?vue&type=script&lang=js&"
export * from "./LibraryBookTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LibraryBookTemplate.vue?vue&type=style&index=0&id=fb9693d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9693d6",
  null
  
)

export default component.exports